import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export const fetchFooterText = async () => {
    const {data, status} = await performRequest({
        url: '/footer/commercial-secret',
        method: ERequestType.GET,
    });
    return {data, status};
};

export const fetchLoginIpData = async () => {
    const {data, status} = await performRequest({
        url: '/footer/login-ip',
        method: ERequestType.GET,
    });
    return {data, status};
};
